import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';
import { genericRoute } from '../../routes';

import { toggleMenu } from '../../actions/menus';

import css from './postVacancy.scss';

export default class PostVacancy extends Component {
	static propTypes = {};

	render() {
		return (
			<Link to={genericRoute(false, 'submit/job')} className='button button-postvacancy' onClick={this.closeMenu.bind(this)}>Post a job vacancy</Link>
		);
	}

	closeMenu() {
		this.props.dispatch(toggleMenu());
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/components/jobs/postVacancy.js
 **/